import Helpers from "../base/Helpers";

const selectors = {
  discountForm: '#discountForm',
  discountInput: '#discount_input',
  contactTags: '#contact_tags',
  discountError: '#discount_error'
}

$(selectors.discountForm).on('submit', e => {
  $(selectors.discountError).hide()
  e.preventDefault()
  const discount_code = $(selectors.discountInput).val()
  asyncHadnle(discount_code, e)
})

function handleDiscountSubmit(discount_code) {
  const url = '/apps/discountz-api/discount-info'
  if (!!discount_code) {
    return fetch(
        url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            code: discount_code
          }),
        }
      )
      .then(function (response) {
        return response.status === 200 ? response.text() : null;
      })
      .then(function (data) {
        let result = {}
        try {
          result = JSON.parse(data)
        } catch (error) {
          result.status = "NOT_ACTIVE"
        }
        if (!!result && result.status === "ACTIVE") {
          Helpers.setCookie("discount_code", discount_code, 365);
          return true;
        } else {
          Helpers.setCookie("discount_code", "", 365);
          $(selectors.discountError).show()
          return false;
        }
      });
  }
  return Promise.resolve();
}

async function asyncHadnle(discount_code, e) {
  const result = await handleDiscountSubmit(discount_code);
  if (result === true) {
    $(selectors.contactTags).val('voucher_page, discount_code__' + discount_code)
    e.target.submit()
  }
}